import { colors } from './colors'
import { typography } from './typography'

const codeFontFamily = typography.fontFamily.mono

/** Dense working surfaces, not document typography or a global theme override. */
export const workspace = {
  surface: colors.background.card,
  subtle: colors.background.surface,
  border: colors.border.subtle,
  accent: colors.accent.main,
  // Text-bearing workspace actions need stronger contrast than the decorative brand accent.
  action: '#B74726',
  actionHover: '#963A20',
  text: colors.text.primary,
  muted: colors.text.secondary,
  font: { ...typography.scale.body, fontFamily: typography.fontFamily.primary },
  supporting: typography.artifact.supporting,
  code: { ...typography.artifact.code, fontFamily: codeFontFamily, lineHeight: 1.6 },
  radius: 6,
  controlHeight: 28,
  touchControlHeight: 44,
  toolbarHeight: 36,
  headerHeight: 48,
  headerPrimaryMinWidth: 160,
  scrollbarSize: 8,
  editor: { fontFamily: codeFontFamily, fontSize: 14, lineHeight: 23 },
  separatorSize: 6,
  separatorStep: 24,
  compactBreakpoint: 780,
  filesBreakpoint: 1050,
  chat: { initial: 440, min: 280, max: 720, collapsed: 40 },
  files: { initial: 208, min: 160, max: 360, overlay: 272 },
  comparison: { stackBelow: 520, sourceMin: 160, sourceMax: 800, targetMin: 240 },
  output: { initial: 180, min: 140, max: 640 },
  column: { initial: 180, min: 88, max: 800 },
} as const

/** Scoped native scrolling for file lists and history; Monaco uses its own options. */
export const workspaceScrollbars = {
  scrollbarWidth: 'thin',
  scrollbarColor: `${colors.neutral[500]} transparent`,
  '&::-webkit-scrollbar': { width: workspace.scrollbarSize, height: workspace.scrollbarSize },
  '&::-webkit-scrollbar-track': { background: 'transparent' },
  '&::-webkit-scrollbar-thumb': { backgroundColor: colors.neutral[500], borderRadius: workspace.radius },
} as const
